import React, { useEffect, useCallback, useMemo, useState, forwardRef, useImperativeHandle } from 'react';
import { getIn18Text } from 'api';
import styles from './MailTag.module.scss';
import KeySwiftInput from '@web-mail/common/components/KeySwiftInput/KeySwiftInput';
import useStateRef from '@web-mail/hooks/useStateRef';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { apiHolder as api } from 'api';
const eventApi = api.api.getEventApi();
const systemApi = api.api.getSystemApi();
import { useAppSelector, useAppDispatch } from '@web-common/state/createStore';
import { actions as hkActions, validateMailTagHK } from '@web-common/state/reducer/hotkeysReducer';
const getKeyByHkArrary = (list) => {
    if (list) {
        return list.map(item => item.toLowerCase()).join('+');
    }
    return '';
};
const MailTagHotKeyInput = forwardRef((props, ref) => {
    const { tagName, onChange, className, style, account } = props;
    const mailTagHotKeysMap = useAppSelector(state => state.hotKeyReducer.mailTagHotKeysMap);
    const hkMap = useMemo(() => {
        var _a;
        try {
            const accountKey = ((_a = systemApi.getCurrentUser(account)) === null || _a === void 0 ? void 0 : _a.id) || account;
            if (accountKey) {
                return mailTagHotKeysMap[accountKey] || {};
            }
        }
        catch (e) {
            console.error('[error] mailtagHotKey error read local', e);
        }
        return {};
    }, [mailTagHotKeysMap, account]);
    const [conflict, setConflict] = useState(false);
    const [hkValue, setHkValue] = useState([]);
    const hkMapRef = useStateRef(hkMap);
    const onChangeRef = useCreateCallbackForEvent(onChange);
    const [initTagName] = useState(tagName);
    const tagNameRef = useStateRef(initTagName);
    const dispatch = useAppDispatch();
    useEffect(() => {
        setHkValue(hkMap[initTagName]);
    }, []);
    useImperativeHandle(ref, () => ({
        saveHk2Local: curTagName => {
            const name = curTagName || initTagName;
            if (validHk(hkValue) && name) {
                dispatch(hkActions.doAddMailTagHotKey({
                    name,
                    hotkey: hkValue,
                    account,
                }));
                eventApi.sendSysEvent({
                    eventName: 'mailMenuOper',
                    eventData: {},
                    eventStrData: 'reloadHotKey',
                });
                return true;
            }
            return false;
        },
        updateHk2Local: params => {
            const { oldName = '', name } = params;
            dispatch(hkActions.doUpdateMailTagHotKey({
                oldName,
                name,
                hotkey: hkValue,
                account,
            }));
            eventApi.sendSysEvent({
                eventName: 'mailMenuOper',
                eventData: {},
                eventStrData: 'reloadHotKey',
            });
        },
        valid: curTagName => {
            return validHk(hkValue, curTagName);
        },
    }));
    const validHk = useCallback((keys, curTagName = tagNameRef.current) => {
        if (getKeyByHkArrary(keys) == '') {
            return true;
        }
        if (!tagNameRef.current) {
            return dispatch(validateMailTagHK({
                hotkey: keys,
                account,
            })).unwrap();
        }
        else {
            if (tagNameRef.current != curTagName) {
                if (getKeyByHkArrary(keys) != getKeyByHkArrary(hkMapRef.current[tagNameRef.current])) {
                    return dispatch(validateMailTagHK({
                        hotkey: keys,
                        account,
                    })).unwrap();
                }
                else {
                    return true;
                }
            }
            else {
                if (getKeyByHkArrary(keys) == getKeyByHkArrary(hkMapRef.current[tagNameRef.current])) {
                    return true;
                }
                else {
                    return dispatch(validateMailTagHK({
                        hotkey: keys,
                        account,
                    })).unwrap();
                }
            }
        }
    }, [account]);
    const handleHkChange = useCallback((keys) => {
        setHkValue(keys);
        onChangeRef(keys);
    }, []);
    const reset = useCallback(() => {
        setConflict(false);
    }, []);
    return (React.createElement("div", { className: "mailtag-hk-wrap", "data-test-id": "mailtag-hk-wrap" },
        React.createElement(KeySwiftInput, { value: hkValue, style: style, className: className, _data_test_id: "mailtag-hk-input", valid: validHk, onValidError: () => setConflict(true), onValidSuccess: () => setConflict(false), onChange: handleHkChange, placeholder: getIn18Text('QINGSHURUBIANQIANKJJ') }),
        conflict ? (React.createElement("div", { className: styles.errorInfo, "data-test-id": "mailtag-hk-info", style: { marginTop: 5 } }, "\u4E0E\u5DF2\u6709\u5FEB\u6377\u952E\u51B2\u7A81\uFF0C\u8BF7\u91CD\u65B0\u8F93\u5165")) : (React.createElement(React.Fragment, null))));
});
export default MailTagHotKeyInput;
